import { GraduationCap, ExternalLink, ChevronRight } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { wagiUrl, WAGI_PATHS, WAGI_ENROLL_LINE } from "@/lib/wagi";

const TEACHERS = [
  { name: "Apostle Dayna Milam", role: "Founder & Teacher" },
  { name: "Prophet Jamie Boersma", role: "Teacher" },
];

const PATH_STEPS = ["Year 1 | Freedom", "Year 2 | Discipleship", "Certificate of Ministry"];

export default function WagiAboutSection() {
  return (
    <section data-testid="wagi-about-section" className="py-20 bg-bone">
      <div className="container-page">
        <div className="text-center mb-12">
          <div className="gold-line-center mb-4" />
          <h2 className="font-heading text-3xl md:text-4xl text-navy mb-4">Training &amp; Equipping</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Apostle Dayna founded Word Alive Global Center and, in 2019, Word Alive Global Institute: college-level ministry training, accredited by ACEA, for leaders called to Kingdom purpose.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-8">
          {TEACHERS.map((t) => (
            <Card key={t.name} className="bg-white border border-bone-dark">
              <CardContent className="p-6 flex items-center gap-4">
                <div className="w-14 h-14 rounded-full bg-navy flex items-center justify-center shrink-0">
                  <GraduationCap className="h-6 w-6 text-gold" />
                </div>
                <div>
                  <h3 className="font-heading text-lg text-navy">{t.name}</h3>
                  <p className="text-gold text-sm font-medium">{t.role}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-2 mb-8" data-testid="wagi-path-steps">
          {PATH_STEPS.map((s, i) => (
            <div key={s} className="flex items-center gap-2 sm:flex-1">
              <div className="flex-1 text-center bg-navy text-white text-sm font-heading py-3 px-4 rounded-sm">{s}</div>
              {i < PATH_STEPS.length - 1 && <ChevronRight className="h-5 w-5 text-gold shrink-0 hidden sm:block" />}
            </div>
          ))}
        </div>

        <p className="text-center text-gray-600 text-sm mb-1">9 courses · three 12-week trimesters a year · online and self-paced</p>
        <p className="text-center text-navy text-sm font-semibold mb-8">{WAGI_ENROLL_LINE}</p>

        <div className="flex flex-wrap justify-center gap-3">
          <a
            href={wagiUrl("about")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="wagi-about-cta"
            className="inline-flex items-center gap-2 bg-navy text-gold font-bold uppercase tracking-wider text-xs h-12 px-7 rounded-full hover:bg-navy/90 transition-colors"
          >
            Explore the Institute <ExternalLink className="h-4 w-4" />
          </a>
          <a
            href={wagiUrl("about", WAGI_PATHS.courses)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="wagi-about-courses-link"
            className="inline-flex items-center gap-2 border border-navy/30 text-navy font-bold uppercase tracking-wider text-xs h-12 px-7 rounded-full hover:border-gold hover:text-gold transition-colors"
          >
            View Courses
          </a>
        </div>
      </div>
    </section>
  );
}
